module.exports = __webpack_public_path__ + "img/08-atelier-informatique.636dd44e.jpg";